
/**
 * Blueprint for the Website entity.
 */
export class Website {
  public id: number;
  public headerColor: string;
  public footerColor: string;
  public buttonColor: string;
  public title: string;
  public lotteryEventUrl: string;
  public links: Links;

  constructor(website: any) {
    this.id = website.id;
    this.headerColor = website.headerColor;
    this.footerColor = website.footerColor;
    this.buttonColor = website.buttonColor;
    this.title = website.title;
    this.lotteryEventUrl = website.lotteryEventUrl;
    this.links = new Links(website.links);
  }

}

export class Links {
  public imprint: string;
  public lotteryEvent: string;
  public dataPrivacy: string;
  public toc: string;
  public ssoLogout: string;
  public accountManagement: string;
  public progressiveProfiling: string;

  constructor(links: any) {
    this.imprint = links.imprint;
    this.lotteryEvent = links.lotteryEvent;
    this.dataPrivacy = links.dataPrivacy;
    this.toc = links.toc;
    this.ssoLogout = links.ssoLogout;
    this.accountManagement = links.accountManagement;
    this.progressiveProfiling = links.progressiveProfiling;
  }
}
